export default {
  index: 'mailing-templates',
  store: 'admin-mailing-templates-add',
  edit: 'admin-mailing-templates-edit',
};
